/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useEffect, useState } from 'react';
// import { Dialog } from '@fluentui/react';
import { Dialog, Dropdown, Language, TextField } from '@eta/components';
import { useTranslation } from 'react-i18next';
import { ConnectedProps, connect } from 'react-redux';
import './RetireDialog.scss';
import {
    DefaultButton,
    Icon,
    IDropdownOption,
    MessageBar,
    MessageBarType,
    PrimaryButton,
    Spinner,
    SpinnerSize,
    TooltipHost,
    // eslint-disable-next-line import/imports-first
} from '@fluentui/react';

// eslint-disable-next-line import/imports-first
import clsx from 'clsx';
import { ServiceCreator } from '../../../Services/ClientProxy/ServiceFactory';
// eslint-disable-next-line import/imports-first
import { ReduxState } from '../../../common/reducers';
import { POSStatus } from '../../../common/config/constants';
import {
    ApiException,
    LookupsDto,
    RetireDevicesRequestDto,
    RevertRetireDevicesRequestDto,
} from '../../../Services/POS/PosService';
import { UIHelpers } from '../../../helpers/UIHelpers';
// import { UIHelpers } from '../../../helpers/UIHelpers';

export interface Props {
    hidden: boolean;
    onClose: () => void;
    onSave: (count?: number) => void;
    language?: Language;
    data?: any;
    multiple?: boolean;
}

const mapStateToProps = (state: ReduxState) => ({
    currentLanguage: state.reduxlanguage.language,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
const RetireDialog: FC<PropsFromRedux & Props> = (
    props: PropsFromRedux & Props
) => {
    const { t } = useTranslation(['pos', 'common']);
    const { hidden, onClose, multiple, data, onSave, currentLanguage } = props;
    const [error, setError] = useState<string | undefined>();
    const [reasonId, setreasonId] = useState<string>();
    const [otherReason, setotherReason] = useState<string>();
    const [reasons, setReasons] = useState<IDropdownOption[]>([]);
    // const [config, setconfig] = useState<any>();
    const [Loading, setLoading] = useState<boolean>(false);
    const [isRetire, setIsRetire] = useState<boolean>();
    const [itemName, setItemName] = useState<string>();
    const [retiringWindow, setRetiringWindow] = useState<number>();

    useEffect(() => {
        if (hidden) {
            const getLookups = async () => {
                const client = ServiceCreator.getPosManagementPublicClient();
                const lookups = await client.config(currentLanguage.lang);
                const arr =
                    lookups?.deviceRetirementReasons?.map<IDropdownOption>(
                        (c: LookupsDto) =>
                            ({
                                key: c.id?.toString() ?? '0',
                                text:
                                    (currentLanguage?.lang?.startsWith('ar')
                                        ? c.nameSecondaryLang
                                        : c.namePrimaryLang) ?? '',
                            } ?? [])
                    ) ?? [];
                setReasons(arr ?? []);
                setRetiringWindow(lookups.retiringWindow);
            };

            getLookups();
            if (!multiple) {
                const { name, status, statusId } = data;
                const st = status
                    ? status === 'Active' ||
                      status === 'Pending' ||
                      status === 'InActive'
                    : statusId === POSStatus.Active ||
                      statusId === POSStatus.Pending ||
                      statusId === POSStatus.InActive;
                setItemName(name);
                setIsRetire(st);
            } else {
                const { status, statusId } = data[0];
                const st = status
                    ? status === 'Active' ||
                      status === 'Pending' ||
                      status === 'InActive'
                    : statusId === POSStatus.Active ||
                      statusId === POSStatus.Pending ||
                      statusId === POSStatus.InActive;
                setItemName(`${data?.length} ${t('Devices')}`);
                setIsRetire(st);
            }
        }
    }, [hidden]);

    const onSaveRequest = async () => {
        setLoading(true);
        try {
            const client = ServiceCreator.getPosManagementPublicClient();
            const list = [];
            if (multiple) {
                for (let i = 0; i < data?.length; i += 1) {
                    list.push(data[i].id);
                }
            } else {
                list.push(data.id);
            }
            if (isRetire) {
                const obj = new RetireDevicesRequestDto();
                obj.devices = list;
                obj.reasonId = reasonId
                    ? Number.parseInt(reasonId, 10)
                    : undefined;
                obj.customReason = otherReason;
                await client.retireDevices(obj);
            } else {
                const obj = new RevertRetireDevicesRequestDto();
                obj.devices = list;
                await client.revertRetireDevices(obj);
            }

            onSave();
        } catch (ex) {
            const exp = ex as ApiException;
            const err = UIHelpers.GetCustomErrors(exp);
            setError(err.message);
        }
        setLoading(false);
    };

    return (
        <Dialog
            containerClassName={!isRetire ? 'revertDialog' : 'retireDialog'}
            hidden={!hidden}
            onDismiss={() => {
                onClose();
            }}
            // loadingText={loadingText}
            // modalProps={modalProps}
            maxWidth={550}
            title={(
                <>
                    <div className={clsx(!isRetire ? 'revert' : 'retirePOS')}>
                        {`${t(!isRetire ? 'Revert' : 'RetirePOS', {
                            device: itemName,
                        })}`}
                    </div>
                </>
              )}
        >
            <div className="content">
                {error && (
                    <MessageBar messageBarType={MessageBarType.error}>
                        {error}
                    </MessageBar>
                )}
                {isRetire && (
                    <Dropdown
                        className="reason-dropDown"
                        label={t('ReasonWhyRetirePOS')}
                        options={reasons ?? []}
                        selectedKey={reasonId}
                        required
                        onChange={(_, option) => {
                            setreasonId(option?.key.toString() ?? '0');
                        }}
                    />
                )}
                {!isRetire ? (
                    <p>
                        <span>
                            {t(
                                multiple
                                    ? 'revertMultipleDevices'
                                    : 'itwillbeabletosubmitreceiptsagain'
                            )}
                        </span>{' '}
                        <span className="bold">
                            {t('itwillbeabletosubmitreceiptsagain1')}
                        </span>
                    </p>
                ) : (
                    reasonId === '0' && (
                        <>
                            <div className="title-reason">
                                <div className="content-titleReason">
                                    <span>{t('Pleaseenterareason')}</span>{' '}
                                    <span>{`(${
                                        100 - (otherReason?.length ?? 0)
                                    } ${t('100charremaining')})`}</span>
                                    <span>*</span>
                                </div>
                                <TooltipHost
                                    closeDelay={500}
                                    tooltipProps={{
                                        onRenderContent: () => (
                                            <div className="notesTooltip">
                                                <p>
                                                    {t(
                                                        'textshouldbeminimum10characters'
                                                    )}
                                                </p>
                                                <p>
                                                    {t(
                                                        'textshouldbemaximum100characters'
                                                    )}
                                                </p>
                                                <p>
                                                    {t(
                                                        'donotusespecialcharacters'
                                                    )}
                                                </p>
                                                <p>
                                                    {t(
                                                        'donotusemultiplespacesconsecutively'
                                                    )}
                                                </p>
                                                <p>
                                                    {t(
                                                        'donotstartorendwithaspace'
                                                    )}
                                                </p>
                                                <p>{t('donotdoXYZ')}</p>
                                            </div>
                                        ),
                                        maxWidth: '350',
                                    }}
                                >
                                    <Icon iconName="info" />
                                </TooltipHost>
                            </div>

                            <TextField
                                className="reasonArea"
                                multiline
                                label={t('')}
                                value={otherReason}
                                onChange={(_, val) => {
                                    setotherReason(val);
                                }}
                                maxLength={100}
                            />
                        </>
                    )
                )}
                {isRetire && (
                    <>
                        <MessageBar
                            className="warning-reason"
                            messageBarType={MessageBarType.warning}
                        >
                            <span>
                                {`${t('warningtext', {
                                    Hours: retiringWindow,
                                })}`}
                            </span>{' '}
                            <br />
                            <span>{t('warningtext1')}</span>
                        </MessageBar>
                    </>
                )}

                <div className="btns">
                    <hr className={clsx(!isRetire ? 'none' : 'block')} />
                    <div
                        className={clsx(
                            !isRetire ? 'revert-btns' : 'retireBOS-btns',
                            'btn-retireDialog'
                        )}
                    >
                        <DefaultButton
                            iconProps={{ iconName: !isRetire ? '' : 'cancel' }}
                            text={
                                !isRetire
                                    ? t('NoKeepCurrentStatus')
                                    : t('common:cancel')
                            }
                            onClick={() => {
                                onClose();
                            }}
                        />

                        <PrimaryButton
                            iconProps={{ iconName: !isRetire ? '' : 'Accept' }}
                            text={!isRetire ? t('revert') : t('RetirePOS')}
                            onClick={() => onSaveRequest()}
                        >
                            {Loading && <Spinner size={SpinnerSize.small} />}
                        </PrimaryButton>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default connector(RetireDialog);
